export function avatarInitials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
}

function hashString(str: string): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return Math.abs(hash);
}

export function participantColors(
  name: string,
  dark: boolean
): { bg: string; text: string } {
  const hue = hashString(name) % 360;
  if (dark) {
    return {
      bg: `hsl(${hue}, 35%, 28%)`,
      text: `hsl(${hue}, 50%, 80%)`,
    };
  }
  return {
    bg: `hsl(${hue}, 45%, 88%)`,
    text: `hsl(${hue}, 55%, 28%)`,
  };
}
